
import { mapGetters } from 'vuex'
export default {
  inject: ['wordingPageProduct'],
  props: {
    bundlePrice: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      product: null,
    }
  },
  computed: {
    ...mapGetters({
      vxLoyaltyTier: 'loyalty/getLoyaltyTier',
    }),
    loyaltyPointsWording() {
      let rewardsMultiplier

      if (this.vxLoyaltyTier) {
        rewardsMultiplier = this.vxLoyaltyTier.position === 2 ? 10 : 5
      } else {
        rewardsMultiplier = 5
      }

      const productRewardsPoints = parseInt(
        parseFloat(this.bundlePrice) * rewardsMultiplier
      )

      const pointsWording = this.wordingPageProduct?.buy_box_loyaltypoints
      const parsedWording = pointsWording.replace(
        'X',
        productRewardsPoints.toLocaleString()
      )
      return parsedWording
    },
    isFinalSale() {
      return this.product?.isFinalSale
    },
  },
}
